module.exports = __webpack_public_path__ + "img/英文.fc4ccf40.png";